import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'tramites/plantillas-de-tramites';

/**
 * GET Plantillas Tramites
 * param {object} params
 * @returns {Promise<object>}
 */
export const getPlantillasTramites = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    response.data.results = response.data.results.map((e) => ({
      ...e,
      pasos_para_tramites: e.pasos_para_tramites?.sort((a, b) => a.orden - b.orden) || [],
    }));
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Plantilla de Tramite
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getPlantillaTramite = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    response.data.pasos_para_tramites = response.data.pasos_para_tramites
      ?.sort((a, b) => a.orden - b.orden) || [];
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Plantilla de Tramite indexada
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPlantillaIndexada = async (id) => {
  try {
    const response = await API.get(`${baseURI}-indexada/${id}`);
    response.data.pasos_para_tramites = (response.data.pasos_para_tramites || [])
      ?.sort((a, b) => a.orden - b.orden);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Plantillas de Tramite indexadas
 * @param {object} params
 * @returns {Promise<object>}
 */
export const getPlantillasIndexadas = async (params) => {
  try {
    const response = await API.get(`${baseURI}-indexada`, { params });
    if (!response.data.next) return response.data.results;
    const page = new URL(response.data.next).searchParams.get('page');
    const _plantillas = await getPlantillasIndexadas({ ...params, page });
    return response.data.results.concat(_plantillas);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Plantilla de Tramite
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPlantillaTramite = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Plantilla de Tramite
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPlantillaTramite = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Plantilla de Tramite
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deletePlantillaTramite = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
